import Client from '../HttpClient';

const numbatUrl = '/gateway/numbat-api/api/vs/manage-config/table-page';
const list = () => {
	return Client.get('/admin/api/table-page');
};
const listCloud = (merchantId, branchId) => {
	return Client.get(`${numbatUrl}/${merchantId}/${branchId}`);
};

const find = (PageNo) => {
	return Client.get(`/admin/api/table-page/${PageNo}`);
};

const create = (PageNo, Description) => {
	return Client.post(`/admin/api/table-page`, {
		PageNo,
		Description,
	});
};
const createCloud = (merchantId, branchId, PageNo, Description) => {
	return Client.post(`${numbatUrl}/${merchantId}/${branchId}`, {
		PageNo,
		Description,
	});
};

const update = (PageNo, Description) => {
	return Client.put(`/admin/api/table-page/${PageNo}`, {
		PageNo,
		Description,
	});
};
const updateCloud = (merchantId, branchId, PageNo, Description) => {
	return Client.put(`${numbatUrl}/${merchantId}/${branchId}/${PageNo}`, {
		PageNo,
		Description,
	});
};

const remove = (PageNo) => {
	return Client.del(`/admin/api/table-page/${PageNo}`);
};
const removeCloud = (merchantId, branchId, PageNo) => {
	return Client.del(`${numbatUrl}/${merchantId}/${branchId}/${PageNo}`);
};

export default {
	list,
	find,
	create,
	update,
	remove,
	listCloud,
	createCloud,
	updateCloud,
	removeCloud,
};
